import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import CustomCursor from "@/components/site/CustomCursor";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";

const Shell = ({ children }) => {
  useLenis();
  return (
    <>
      <CustomCursor />
      <Nav />
      {children}
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0b0b0c",
            border: "1px solid #26262a",
            color: "#f6f5f2",
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.05em",
          },
        }}
      />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
